import React, { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';
import './ProfilePage.css';

const xpForLevel = (level) => 50 * Math.pow(level - 1, 2);

export default function ProfilePage() {
    const { user } = useAuth();
    const [progress, setProgress] = useState(null);
    const [artifacts, setArtifacts] = useState([]);
    const [postcards, setPostcards] = useState([]);
    const [achievements, setAchievements] = useState([]);
    const [tab, setTab] = useState('artifacts');

    useEffect(() => {
        api.get('/profile/').then((r) => setProgress(r.data.progress))
        api.get('/profile/artifacts').then((r) => setArtifacts(r.data))
        api.get('/profile/postcards').then((r) => setPostcards(r.data))
        api.get('/profile/achievements').then((r) => setAchievements(r.data))
    }, []);

    if (!progress) return <div className='loading-screen'><div className='spinner' /></div>;

    const lvl = progress.erudition_level;
    const xpMin = xpForLevel(lvl);
    const xpMax = progress.xp_for_next_level;
    const xpCurrent = progress.total_xp - xpMin;
    const xpNeeded = xpMax - xpMin;
    const pct = Math.min(100, Math.round((xpCurrent / xpNeeded) * 100)) || 0;

    const TABS = [
        ['artifacts', '🏺 Артефакты'],
        ['postcards', '📮 Открытки'],
        ['achievements', '🏆 Достижения']
    ];

    return (
        <div className='profile-page'>
      <div className='profile-header'>
        <div className='profile-avatar'>{user?.username?.[0]?.toUpperCase()}</div>
        <div>
          <h2>{user?.username}</h2>
          <span className='profile-level'>Уровень эрудиции: {lvl}</span>
        </div>
      </div>

      <div className='xp-section'>
        <div className='xp-label'>
          <span>{progress.total_xp} XP</span>
          <span>До уровня {lvl + 1}: {Math.max(0, xpNeeded - xpCurrent)} XP</span>
        </div>
        <div className='xp-bar-bg'>
          <div className='xp-bar-fill' style={{ width: `${pct}%` }} />
        </div>
      </div>

      <div className='stats-row'>
        {[
          [progress.locations_visited, 'Локаций'],
          [progress.artifacts_collected, 'Артефактов'],
          [progress.quests_completed, 'Квестов'],
          [achievements.length, 'Наград']
        ].map(([val, label]) => (
          <div key={label} className='stat-card'>
            <span className='stat-value'>{val}</span>
            <span className='stat-label'>{label}</span>
          </div>
        ))}
      </div>

      <div className='collection-tabs'>
        {TABS.map(([key, label]) => (
          <button
            key={key}
            className={`col-tab-btn ${tab === key ? 'active' : ''}`}
            onClick={() => setTab(key)}
          >
            {label}
          </button>
        ))}
      </div>

      <div className='collection-body'>
        {tab === 'artifacts' && (
          artifacts.length === 0
            ? <p className='empty-hint'>Коллекция пуста — исследуйте локации!</p>
            : <div className='artifact-grid'>
                {artifacts.map((a) => (
                  <div key={a.id} className='artifact-tile'>
                    <div className='artifact-icon'>🏺</div>
                    <strong>{a.name}</strong>
                    <span>{a.artifact_type} · {a.era}</span>
                  </div>
                ))}
              </div>
        )}

        {tab === 'postcards' && (
          postcards.length === 0
            ? <p className='empty-hint'>Открыток нет — посетите объекты!</p>
            : <div className='postcard-grid'>
                {postcards.map((p) => (
                  <div key={p.id} className='postcard-card'>
                    {p.image_url && <img src={p.image_url} alt={p.title} />}
                    <p>{p.title}</p>
                  </div>
                ))}
              </div>
        )}

        {tab === 'achievements' && (
          achievements.length === 0
            ? <p className='empty-hint'>Достижений нет — начните исследование!</p>
            : <div className='achievement-list'>
                {achievements.map((a) => (
                  <div key={a.id} className='achievement-item'>
                    <span className='ach-icon'>{a.icon}</span>
                    <div>
                      <strong>{a.title}</strong>
                      <p>{a.description}</p>
                    </div>
                  </div>
                ))}
              </div>
        )}
      </div>
    </div>
    );
}
